import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Loader, Center } from "@mantine/core";

export default function RootRedirect() {
   const { user, loading } = useAuth();
   const navigate = useNavigate();

   useEffect(() => {
      if (!loading) {
         if (user) {
            navigate("/dashboard", { replace: true });
         } else {
            navigate("/login", { replace: true });
         }
      }
   }, [user, loading, navigate]);

   return (
      <Center style={{ minHeight: "100vh" }}>
         <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#699269]"></div>
      </Center>
   );
}
